import styled from 'styled-components';

export const SelectedListStyled = styled.div`
  width: 100%;
  .selectedList {
    &__header {
      align-items: center;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 16px;
    }
      
    &__button {
      padding: 0;
    }
      
    &__titleContainer {
      color: ${props => props.theme.uiColors.forecastHeaderColor};
      display: flex;
      flex-direction: row;
      font-size: 14px;
      gap: 4px;
    }
    
    &__item {
      align-items: center;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      border-bottom: 1px solid ${props => props.theme.uiColors.reportingBorderColor};
      &:last-child {
        border-bottom: none;
      }
    }
      
    &__name {
      align-items: center;
      color: ${props => props.theme.uiColors.textBodyDefault};
      display: flex;
      font-size: ${props => props.theme.fontSizeXS};
      height: 32px;
    }
  }
`;
